"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import { Price } from "@/components/Price/Price.component";
import { calculateYearlyProductMinimumPrice } from "@/components/ProductTerms/_utilities/calculate-yearly-product-minimum-price";
import { Spinner } from "@/components/Spinner/Spinner.component";
import { Translation } from "@/components/Translation/Translation.component";
import { useProductCountryVat } from "@/contexts/products/product-country-vat.context";
import type { ProductModel } from "@/services/api/shop/models/product.model";
import { captureClientException } from "@/services/logging/capture-client-exception";
type YearlyProductMinimumPriceProps = {
  readonly product: ProductModel;
  readonly isVatCalculationEnabled: boolean;
  readonly yearlyProductTerminationMonths: number;
};
export function YearlyProductMinimumPrice(t0) {
  const $ = _c(18);
  const {
    product,
    isVatCalculationEnabled,
    yearlyProductTerminationMonths
  } = t0;
  const [price, setPrice] = useState(isVatCalculationEnabled ? null : product.price);
  const {
    countryCode,
    getPriceWithVat,
    isPending
  } = useProductCountryVat();
  let t1;
  let t2;
  if ($[0] !== countryCode || $[1] !== getPriceWithVat || $[2] !== isVatCalculationEnabled || $[3] !== product) {
    t1 = () => {
      if (countryCode === null || product === null || !isVatCalculationEnabled) {
        return;
      }
      getPriceWithVat(product).then(setPrice).catch(captureClientException);
    };
    t2 = [countryCode, product, getPriceWithVat, isVatCalculationEnabled];
    $[0] = countryCode;
    $[1] = getPriceWithVat;
    $[2] = isVatCalculationEnabled;
    $[3] = product;
    $[4] = t1;
    $[5] = t2;
  } else {
    t1 = $[4];
    t2 = $[5];
  }
  useEffect(t1, t2);
  if (isPending || price === null) {
    let t3;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <Spinner className="inline-block h-2 w-2 rounded-full fill-primary text-whisper" />;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    return t3;
  }
  let t3;
  if ($[7] !== price || $[8] !== yearlyProductTerminationMonths) {
    t3 = calculateYearlyProductMinimumPrice(price, yearlyProductTerminationMonths);
    $[7] = price;
    $[8] = yearlyProductTerminationMonths;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const minimumPrice = t3;
  let t4;
  if ($[10] !== minimumPrice || $[11] !== product.currency) {
    t4 = <Price currency={product.currency} price={minimumPrice} />;
    $[10] = minimumPrice;
    $[11] = product.currency;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== isVatCalculationEnabled) {
    t5 = isVatCalculationEnabled ? <Translation da="inkl. moms" de="inkl. MwSt" en="incl. VAT" no="inkl. mva" sv="inkl. moms" /> : <Translation da="ekskl. moms" de="exkl. MwSt" en="excl. VAT" no="ekskl. mva" sv="exkl. moms" />;
    $[13] = isVatCalculationEnabled;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== t4 || $[16] !== t5) {
    t6 = <span className="inline-flex gap-0.5">{t4}{" "}{t5}</span>;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  return t6;
}